// @flow

import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { withStyles } from '@material-ui/core/styles';

const style = () => ({
    root: {
        padding: 8,
    },
    fullWidth: {
        width: '100%',
    },
});

type SearchStyleClasses = {
    root: string,
    fullWidth: string,
};

type Props = {
    onSearch: Function,
    onChange: Function,
    onForceUpdate: Function,
    elevation: number,
    fullWidth: boolean,
    autoFocus: boolean,
    defaultValue: string,
    value: string,
    classes: SearchStyleClasses
};

type State = {
    value: string,
};

class Search extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            value: props.defaultValue || ''
        };
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.value !== this.props.value) {
            this.setState({
                value: this.props.value,
            })
        }
    }

    handleOnChange = (event) => {
        this.setState({ value: event.target.value }, () => {
            if (this.props.onChange) {
                this.props.onChange(this.state.value)
            }
        });
    };

    handleOnKeyPress = (event) => {
       if (event.keyCode === 13) {
           this.props.onSearch(this.state.value);
       }
    };

    getPaperStyles = () => {
        const paperStyles = [
            this.props.classes.root,
        ];

        if (this.props.fullWidth) {
            paperStyles.push(this.props.classes.fullWidth);
        }

        return paperStyles;
    };

    render() {
        const paperStyles = this.getPaperStyles();

        return (
            <Paper
                elevation={this.props.elevation}
                className={paperStyles.join(' ')}
            >
                <Input
                    onChange={this.handleOnChange}
                    onKeyUp={this.handleOnKeyPress}
                    autoFocus={this.props.autoFocus}
                    startAdornment={
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    }
                    value={this.state.value}
                    fullWidth
                    disableUnderline
                    placeholder="Search..."
                />
            </Paper>
        );
    }
}

export default withStyles(style)(Search);